import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import SEO from "@/components/SEO";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { TESTIDS } from "@/constants/testIds";
import { ASSETS } from "@/constants/site";

export default function AdminLogin() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo(a)!");
      nav("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Falha no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <SEO title="Área restrita" description="Login administrativo Visiovet" path="/admin/login" />
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <img src={ASSETS.logo} alt="Visiovet" className="h-14 w-auto" />
        </Link>

        <div className="bg-white rounded-3xl border border-slate-200 shadow-xl p-8">
          <div className="flex items-center gap-2 mb-6">
            <Lock className="w-5 h-5 text-brand-500" />
            <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Entrar</h1>
          </div>

          <form data-testid={TESTIDS.adminLoginForm} onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" data-testid={TESTIDS.adminLoginEmail} type="email" className="mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <Label htmlFor="password">Senha</Label>
              <Input id="password" data-testid={TESTIDS.adminLoginPassword} type="password" className="mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid={TESTIDS.adminLoginSubmit}
              className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-500 text-white font-semibold px-6 py-3 shadow-lg shadow-brand-500/30 hover:bg-brand-600 disabled:opacity-60 transition-colors"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Acessar painel
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
